import React from 'react';

const TableView = ({ data }) => {

  const handleDownload = (event, item) => {
    event.preventDefault();

    const csvContent = `
      Sent at,Broadcast Name,Contacts,Language,Template,WhatsApp Area,Status,Confirmations\n
      ${item.date},${item.title},${item.contact},${item.lang},${item.template},${item.whatsapp},${item.sent},${item.confirms}
    `;

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `${item.title}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <table className='table-bordered container-fluid table text-center mb-0'>
      <thead>
        <tr>
          <th className='table-head' scope='col'>Sent at</th>
          <th className='table-head' scope='col'>Broadcast Name</th>
          {/* <th className='table-head' scope='col'>Store Name</th> */}
          <th className='table-head' scope='col'>Contacts</th>
          <th className='table-head' scope='col'>Language</th>
          <th className='table-head' scope='col'>Template</th>
          <th className='table-head' scope='col'>WhatsApp Area</th>
          {/* <th className='table-head' scope='col'>Stop notifications </th> */}
          <th className='table-head' scope='col'>Status</th>
          {/* */}
          <th className='table-head' scope='col'>Confirmations</th>
        </tr>
      </thead>
      <tbody className=''>
        {data.map((item) => (

          <tr>
            <td className='px-2'>{item.date}</td>
            <td className='px-2'>{item.title}</td>
            {/* <td className='px-2'>{item.store}</td> */}
            <td className='px-2'>{item.contact}</td>
            <td className='px-2'>{item.lang}</td>
            <td className='px-2'>{item.template}</td>
            <td className='px-2'>{item.whatsapp}</td>
            {/* <td className='px-4'>{item.notification}</td> */}
            <td className='px-2'>
              <div className='d-flex justify-content-center align-items-center'>
                <span className={`d-flex me-auto`}>
                  <img width={10} className='mx-1' src={item.isSent} alt='' srcSet='' />
                  <span className={item.classSentTxt}>{item.sent}</span>
                </span>
                <span className={`${item.classSent} d-flex ms-auto`}>
                  <a className={`${item.classBtnView} justify-content-center align-items-center btn-view mx-1`} href=''>
                    <img src={item.btnVeiw} alt='' srcSet='' />
                  </a>
                  <a className={`${item.classBtnDownload} btn-download mx-1`} href='#' onClick={(event) => handleDownload(event, item)}>
                    <img src={item.download} alt='' srcSet='' />
                  </a>
                  <a className={`${item.classBtnEdit} btn-edit mx-1`} href=''>
                    <img src={item.btnEdit} alt='' srcSet='' />
                  </a>
                </span>
              </div>

            </td>
            <td className='px-4'>
              <div className={`${item.classConfirms} rounded-pill p-1 align-items-center text-center`}>
                <span className='px-2 py-2'>{item.confirms}</span>
                <img className={item.icDownloadClass} src={item.icDownload} alt='' srcSet='' />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TableView;